module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHBAMAAADDgsFQAAAAMFBMVEUAAACVcS2VcS2VcS2VcS2VcS2VcS2VcS2VcS2VcS2VcS2VcS2VcS2VcS2VcS2VcS2gqQ4GAAAAD3RSTlMAWhAH+Ukr083FgXlwTjaJ/B3fAAAAJ0lEQVQI12OQYQAB+Wlg8stmIHn//48EBob4//+9DEDk/zqQlJESAOJMDNOU9UEVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// D:/Honda/Trunk/WizdomWebApp/Wizdom-Web-App/src/assets/img/label-arrow.png
// module id = ../../../../../src/assets/img/label-arrow.png
// module chunks = styles common